<template>
    <div>
        <div class="text-center col-md-12 col-xs-12 margin-tb sidemenu-padding section-title dark-green-title" style="margin-bottom: 20px;padding: 5px;">
            <div class="text-center" style="display: inline-flex;padding-left: 10px;">
                <span style="font-size: 16px;color:#fff;">Contacts</span>
            </div>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="pull-left col-md-10" style="padding-left:0;margin-bottom:10px;display:inline-flex">
                    <div class="size" style="margin-left:15px">
                        Show
                        <select class="size-select" v-model="size">
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        Entries
                        
                    </div>

                    <div class="sortBy" style="margin-left:15px">
                        Sort By
                        <select class="sortBy-select" v-model="sortBy">
                            <option value="Name">Name</option>
                            <option value="Property">Property</option>
                        </select>
                        
                        
                    </div>
                    
                    <div class="search col-md-6" style="margin-left:15px;min-width:400px">
                        <span class="fa fa-search"></span>
                        <input type="text" class="form-control" name="searchText" id="searchText" placeholder="Search contact" v-model="filter">
                    </div>
                
                </div>
                <div class="pull-right" style="margin-bottom:10px;">
                    <router-link class="btn btn-primary" :to="{name:'contact', params:{buildingId:buildingId, buildingName:buildingName}}">Add New Contact</router-link>
                </div>
                <table class="table table-striped table-condensed table-border">
                    <thead class="thead-style">
                        <tr>
                            <th>No.</th>
                            <th>Property</th>
                            <th>Name</th>
                            <th>Phone number</th>
                            <th>Email</th>
                            <th class="text-center">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="contact, key in paginatedData" class="clickable-row">
                            <td class="clickable-column"><a @click.prevent="editItem(contact)">{{ ++key }}</a></td>
                            <td class="clickable-column"><a @click.prevent="editItem(contact)">{{ contact.propertyName}}</a></td>
                            <td class="clickable-column"><a @click.prevent="editItem(contact)">{{ contact.name}}</a></td>
                            <td class="clickable-column"><a @click.prevent="editItem(contact)">{{ contact.phoneNumber}}</a></td>
                            <td class="clickable-column"><a @click.prevent="editItem(contact)">{{ contact.email}}</a></td>
                            <td style="width:11.5%">
                                <a class="btn btn-delete" @click.prevent="deleteItem(contact)">Delete</a>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <div class="table-summary">
                    <span>  Showing {{startEntry}} to {{endEntry}} of {{numberOfEntries}} entries </span>
                </div>
                <paginate
                        :page-count="numberOfPages"
                        :page-range="3"
                        :margin-pages="2"
                        :click-handler="clickCallback"
                        :prev-text="'<'"
                        :next-text="'>'"
                        :container-class="'pagination'"
                        :page-class="'page-item'">
                        </paginate>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
    data: function(){
        return{
      size: 10,
      sortBy: 'Name',
             filter: '',
      pageNumber: 0,
            contacts :[],
            buildingId:0,
         ///   buildingName:''
        }
    },
    mounted()
    {
        this.buildingId = this.$route.params.buildingId;
         //this.buildingName = this.$route.params.buildingName;
            this.fetchStatement();
    },
    computed:{
        ...mapState({
      building: (state) => state.building.currentBuilding,
      buildings: (state) => state.building.buildings,
      numberOfAllowedBuildings: (state) =>
        state.building.numberOfAllowedBuildings,
    }),
    buildingName(){
      if(this.building != null)
        return  this.building.name;
      return ""
    },
        getContacts() {

                    var committees = this.contacts.filter((supplier) => {
                        return supplier.name.toLowerCase().includes(this.filter.toLowerCase());
                        });

                    return committees;

    },
    numberOfEntries() {
        return this.getContacts.length
    },
    numberOfPages() {
        let l = this.numberOfEntries,
          s = this.size;
      return Math.ceil(l/s);
    },
    startEntry() {
        if (this.numberOfEntries == 0){
            return 0
        } if (this.pageNumber+1 == 1){
            return 1 
        } else {
            return this.pageNumber * this.size +1
        }
    },
     endEntry(){
        if (this.numberOfEntries <= this.size){
            return this.numberOfEntries
        } else if (this.numberOfEntries > this.size && (this.pageNumber+1) == 1 ){
            return this.size
        } else if (this.numberOfEntries > this.size && (this.pageNumber+1) > 1){
            if (this.numberOfEntries-(this.size*(this.pageNumber+1))>0){
                return this.size * (this.pageNumber+1)
            } else {
                return this.numberOfEntries
            }
        } else {
            return NaN
        }
    },
        paginatedData(){
      const start = this.pageNumber * this.size,
          end = start + this.size;
      var sorted = [...this.getContacts];

            if (this.sortBy == 'Name') {
                sorted.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : ((b.name.toLowerCase() > a.name.toLowerCase()) ? -1 : 0));
            }
            else {
                sorted.sort((a, b) => (a.propertyName.toLowerCase() > b.propertyName.toLowerCase()) ? 1 : ((b.propertyName.toLowerCase() > a.propertyName.toLowerCase()) ? -1 : 0));
            }
      return sorted
               .slice(start, end);
    }
    },
    methods: {
         clickCallback (pageNum)  {
      this.pageNumber = pageNum -1
    },
         fetchStatement: function(){
                    this.mute = true;
                    //this.buildingId = 3;
                    var request = '/contacts/building?id='+this.buildingId;
                    this.$http.get(request, {
                        id : this.buildingId
                    }).then(({data}) => {
                                this.mute = false;
                                //this.contacts = data.contacts;
                            this.contacts = data;

                });
            },
            editItem:function(item){
                this.$router.push({name:'contact',params:{id:item.id, buildingId: this.buildingId, buildingName:this.buildingName}})
           }, 
            deleteItem: function destroy(item) {
                var r = confirm("Are you sure you want to delete contact?");
                if (r == true) {
                var _this = this;
                this.axios.delete('/contacts/' + item.id).then(function () {
                    _this.fetchStatement();
                // _this.getVueItems();
                    //_this.hasDeleted = false
                });
                }
      }
    }
}
</script>